// extracted by mini-css-extract-plugin
export default {"grid":"vvh9hs","container":"i46FZo","column":"AfsJOp","row":"a8g5ew"};